module.exports = __webpack_public_path__ + "static/media/empty03_timesheets_anim.97d8e58a.svg";